import axios from 'axios'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import authorization from '../functions/authorization.js'
import DecodeJWT from '../functions/decodeJwt'
import router from '../router'
import store from '../store'
import * as types from './mutation-types'
Vue.use(VueCookies)

axios.defaults.withCredentials = false

export const SET_DATA_ANNOUNCE = ({ commit }, data) => {
  commit(types.SET_DATA_ANNOUNCE, data)
}

export const SET_DATA_BOT_ONEPLATFORM = ({ commit }, data) => {
  commit(types.SET_DATA_BOT_ONEPLATFORM, data)
}
export const SET_UPDATE_BOT = ({ commit }, data) => {
  commit(types.SET_UPDATE_BOT, data)
}
export const SET_DATA_GROUP_ONECHAT = ({ commit }, data) => {
  commit(types.SET_DATA_GROUP_ONECHAT, data)
}
export const SET_CHECKROLE = ({ commit }, data) => {
  commit(types.SET_CHECKROLE, data)
}
export const SET_BUSINESS = ({ commit }, data) => {
  commit(types.SET_BUSINESS, data)
}
export const SET_ROLEACCOUNT = ({ commit }, data) => {
  commit(types.SET_ROLEACCOUNT, data)
}
export const SET_DATA_ACCOUNT = ({ commit }, data) => {
  commit(types.SET_DATA_ACCOUNT, data)
}
export const GET_MENU_DEFAULT = ({ commit }, data) => {
  commit(types.GET_MENU_DEFAULT, data)
}
export const GET_ROLE_ACCESS = ({ commit }, data) => {
  commit(types.GET_ROLE_ACCESS, data)
}
export const SET_STATUS_BUSINESS = ({ commit }, data) => {
  commit(types.SET_STATUS_BUSINESS, data)
}
export const SET_DATA_CONSENT_ONECHAT = ({ commit }, data) => {
  commit(types.SET_DATA_CONSENT_ONECHAT, data)
}
export const SET_DATA_CONSENT_ONECHAT_PATH = ({ commit }, data) => {
  commit(types.SET_DATA_CONSENT_ONECHAT_PATH, data)
}
export const SET_DATA_GENERAL_DASHBOARD = ({ commit }, data) => {
  commit(types.SET_DATA_GENERAL_DASHBOARD, data)
}
export const SET_DATA_GROUP_DASHBOARD = ({ commit }, data) => {
  commit(types.SET_DATA_GROUP_DASHBOARD, data)
}
export const SET_ALLBUSINESS = ({ commit }, data) => {
  commit(types.SET_ALLBUSINESS, data)
}
export const SET_DATAPOLICY = ({ commit }, data) => {
  commit(types.SET_DATAPOLICY, data)
}
export const SET_DATAPETITON = ({ commit }, data) => {
  commit(types.SET_DATAPETITON, data)
}
export const SET_DATACONSENT = ({ commit }, data) => {
  commit(types.SET_DATACONSENT, data)
}
export const SET_DATACONSENTID = ({ commit }, data) => {
  commit(types.SET_DATACONSENTID, data)
}
export const SET_DATA_SMTP_EMAIL = ({ commit }, data) => {
  commit(types.SET_DATA_SMTP_EMAIL, data)
}
export const SET_DATA_CONSENT_GROUP = ({ commit }, data) => {
  commit(types.SET_DATA_CONSENT_GROUP, data)
}
export const SET_DATA_GENERAL_CONSENT = ({ commit }, data) => {
  commit(types.SET_DATA_GENERAL_CONSENT, data)
}
export const SET_DATA_GROUP_CONSENT = ({ commit }, data) => {
  commit(types.SET_DATA_GROUP_CONSENT, data)
}
export const AUTH_PORTAL_SUCCESS = ({ commit }, data) => {
  commit(types.AUTH_PORTAL_SUCCESS, data)
}
export const AUTH_PORTAL_EXPIRED = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    commit(types.AUTH_PORTAL_EXPIRED, data)
  })
}
export const ACCOUNT_PORTAL_SUCCESS = ({ commit }, data) => {
  commit(types.ACCOUNT_PORTAL_SUCCESS, data)
}
export const ACCOUNT_PORTAL_NOTFOUND = ({ commit }, data) => {
  commit(types.ACCOUNT_PORTAL_NOTFOUND, data)
}
export const SET_LOADING_LOGIN = ({ commit }, data) => {
  commit(types.SET_LOADING_LOGIN, data)
}

export const AUTH_PORTAL_CHECK = ({ commit, dispatch }) => {
  return new Promise(async (resolve, reject) => {
    if (Vue.$cookies.isKey('OneAccessToken') === true) {
      commit(types.AUTH_PORTAL_CHECK, Vue.$cookies.get('OneAccessToken'))
      var payload = {
        AccessToken: Vue.$cookies.get('OneAccessToken')
      }
      var Headers = {
        AccountId: Vue.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'token/GetAccountLogin',
          { Data: dataEncode },
          { headers },
          { withCredentials: false }
        )
        .then((response) => {
          if (response.data.Status === 'OK') {
            resolve(response.data)
            commit(types.AUTH_PORTAL_SUCCESS, response.data.Message)
            store.dispatch('SET_DATA_ACCOUNT', response.data.Message)
            // dispatch(types.AUTH_PORTAL_SUCCESS, response.data.Message).then(res=>{
            //   resolve(res)
            // })
          } else {
            commit(types.AUTH_PORTAL_EXPIRED)
            resolve(response.data)
            Vue.$cookies.remove('OneAccessToken')
            Vue.$cookies.remove('OneUsername')
            Vue.$cookies.remove('OneAccountId')
            Vue.$cookies.remove('OneRefreshToken')
            Vue.$cookies.remove('BusinessId')
            localStorage.removeItem('BusinessNameTH')
            localStorage.removeItem('BusinessNameEng')
            localStorage.removeItem('TaxId')
            localStorage.removeItem('lang')
          }
        })
    } else {
      commit(types.AUTH_PORTAL_CHECK, '')
      commit(types.AUTH_PORTAL_EXPIRED)
      resolve({ result: 'fail' })
      Vue.$cookies.remove('OneAccessToken')
      Vue.$cookies.remove('OneUsername')
      Vue.$cookies.remove('OneAccountId')
      Vue.$cookies.remove('OneRefreshToken')
      Vue.$cookies.remove('BusinessId')
      localStorage.removeItem('BusinessNameTH')
      localStorage.removeItem('BusinessNameEng')
      localStorage.removeItem('TaxId')
      localStorage.removeItem('lang')
    }
  })
}

export const SET_MENU = ({ commit, dispatch }) => {
  return new Promise(async (resolve, reject) => {
    if (Vue.$cookies.isKey('BusinessSelect') === true) {
      var Headers = {
        AccountId: Vue.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(
        Vue.$cookies.get('BusinessSelect')
      )
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + 'token/GetRoleAccount',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === 'OK') {
            // store.dispatch('SET_ROLEACCOUNT', response.data.Message)
            var roleAccount = DecodeJWT.FnJwtDecode(response.data.Message).Role
            Vue.$cookies.set('RoleAccount', roleAccount)
            Vue.$cookies.set('RoleAccountId', response.data.Message)
            // for (var i in roleAccount) {
            //   if (roleAccount[i].RoleName === 'owner') {
            //     roleAccount[i].RoleName = 'CMP Approval'
            //   }
            // }
            var NewRoleAccess = roleAccount.map((item) => {
              return item.RoleName
            })
            store.dispatch('SET_CHECKROLE', NewRoleAccess)

            Vue.$cookies.set('CheckAdminName', response.data.Message)
          }
        })
    }
  })
}
